import { useMemo } from "react";
import { useConfiguration } from "system/hooks";
import { Roles } from "system/types/enums/Roles";

const usePolicyEditorPermissions = () => {
  const { roles, isGlobalAdmin } = useConfiguration();

  return useMemo(() => {
    const canEdit = isGlobalAdmin || roles.includes(Roles.PolicyAdmins);
    const canDownload = isGlobalAdmin;
    return {
      canEdit,
      canDownload,
      isReadOnly: !canEdit,
    };
  }, [isGlobalAdmin, roles]);
};

export default usePolicyEditorPermissions;
